
// Email integrator settings live in two places: the account-wide credentials on the
// Integrator — only MailerSend has any, SMTP has none — and the mail sender settings on
// each IntegratorConfig, so a single account can serve several senders (the customer
// email, the admin email…).
//
// Keys are seeded empty on purpose: the integrator server falls back to the venue EMAIL
// configuration (email-config-*) for every empty value, so seeding the keys only makes
// the settings visible and editable, it never changes how a working venue sends its mail.
//
// Mirrors EmailIntegrator.swift in DLIntegratorServer.
class IntegratorEmailDefaults
{
    static isEmailType(type: string): boolean {
        return type == IntegratorType.IntegratorTypeSMTPEmail
            || type == IntegratorType.IntegratorTypeMailersend;
    }

    static accountKeys(type: string): string[] {
        switch (type) {
            case IntegratorType.IntegratorTypeMailersend: return ["Token"];
            default: return [];
        }
    }

    static senderKeys(type: string): string[] {
        switch (type) {
            case IntegratorType.IntegratorTypeSMTPEmail : return ["Host", "Port", "Username", "Password", "From", "FromName"];
            // The API is the transport, so only the sender identity is configurable
            case IntegratorType.IntegratorTypeMailersend: return ["From", "FromName"];
            default: return [];
        }
    }

    // Adds the missing keys and leaves the ones already there untouched
    static seed(values: any, keys: string[]): any {
        let result = values || {};
        for (let index = 0; index < keys.length; index++) {
            if (result[keys[index]] == null) result[keys[index]] = "";
        }
        return result;
    }
}
